export default __webpack_public_path__ + "static/media/icon-viber.9b2980bb.svg";